var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpowerment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.5,
    height: 53.548,
    viewBox: "0 0 53.5 53.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62780",
    "data-name": "Group 62780",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107815",
    "data-name": "Path 107815",
    d: "M117.311,134.355c6.081-5.65,23.861-21.867,23.861-21.867s4.423,5.316,2.209,9.3-7.3,9.526-7.3,9.526l11.425-.358a6.238,6.238,0,0,1,6.512,6.826l-.024.177a120.318,120.318,0,0,1-3.1,13.486s-3.234,11.382-6.853,11.993c-4.933.829-31.539.5-31.539.5",
    transform: "translate(-102.58 -112.488)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24646",
    "data-name": "Rectangle 24646",
    width: 14.693,
    height: 30.707,
    rx: 0.748,
    transform: "translate(0 20.812)",
    fill: "none",
    stroke: "#00a6ef",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpowerment);
export default __webpack_public_path__ + "static/media/empowerment.84fac4e2dfbc7ef2c459400ff27540f0.svg";
export { ForwardRef as ReactComponent };